<template>
	<div class="o-page-login" data-component="passwordforgot"
        :data-component-name="$options.name"
	>
		<div class="o-row">
			<div class="o-col -login-welcome">
				<div class="o-page-login__content">
					<div class="o-page-login__header">
						<SvgIcon name="logo" class="o-page-login__logo" />
					</div>
					<!-- <div class="o-page-login__sub-header">
										Console d'affectation
									</div> -->
					<h1 class="o-page-login__title">
						Gestionnaire <br>haute performance <br>des <strong>affectations</strong>
					</h1>
					<p class="o-page-login__text">
						Optimisez et gérez efficacement les ressources humaines et matérielles nécessaires à la
						réalisation de vos projets grâce à cette application web. Connectez-vous pour accéder à votre
						gestionnaire ou <a href="mailto:info@monriff.ca?subject=Demande d'informations">contactez-nous</a> afin d’en
						savoir plus.
					</p>
					<a href="https://monriff.ca" target="_blank" class="o-button -outline -ico-right o-page-login__button">En savoir
						plus
						<SvgIcon name="external-link" />
					</a>
				</div>
			</div>
			<div class="o-col -login">
				<div class="o-page-connect">
					<h2 class="o-page-connect__title -reset_password">Mot de passe oublié</h2>
                    <div class="o-page-connect__msg" v-if="!sent">Entrez votre adresse courriel pour réinitialiser votre mot de passe.</div>
                    <div class="o-page-connect__msg" v-else v-html="response"></div>
					<q-form @submit.prevent="resetPassword" ref="resetPasswordForm" v-if="!sent">
						<div class="o-form__item o-page-connect__input">
							<q-input
								class="o-page-connect__input"
								label="Nom d'utilisateur"
								v-model="email"
								type="text"
								placeholder="courriel"
								autocomplete="username"
								autofocus
								dense
								borderless
							/>
						</div>
                        <div class="o-page-connect__submit q-mt-md">
                            <div class="o-page-connect__forgotpw">
                                <!-- <router-link :to="{ name: 'forgot' }">Mot de passe oublié?</router-link> -->
                            </div>
                            <div class="o-page-connect__button">
                                <button class="o-button -ico-right" color="primary">Envoyer<SvgIcon name="arrow-right" /></button>
                            </div>
                        </div>
					</q-form>
					<!-- <div class="o-page-connect__createaccount">
						Vous n'avez pas de compte? <router-link :to="{ name: 'register' }">S'enregistrer</router-link>
					</div> -->
				</div>
			</div>
		</div>
	</div>
</template>

<script>
    import { mapActions } from 'vuex'
	import { REQUESTPASSWORDRESET } from '@/graphql/user/mutations'

    export default {
        data() {
            return {
                appName: process.env.VUE_APP_NAME || 'worky.',
                email: '',
                response: '',
                sent: false
            }
        },
        // async created() {
        // },

        methods: {
			...mapActions({'setMyProfile': 'auth/setMyProfile'}),
			async resetPassword() {
                let validation=await this.$refs.resetPasswordForm.validate()
                if(!validation){
                    this.$q.notify({type: 'negative', message: "Informations non savegardées", caption: "Certains champs requis n'ont pas été remplis"});
                    return false;
                }

                this.$apollo.mutate({
                    mutation: REQUESTPASSWORDRESET,
                    variables: { 
                        email: this.email,
                    },
                }).then(() => {
                    this.sent=true;
                    this.response="Un lien de réinitialisation a été envoyé par courriel.<br><br><a href='/login'>Cliquez ici</a> pour revenir à l'écran de connexion."
                }).catch(e => {
                    if (e.message) this.$q.notify({type: 'negative', message: e.message, caption: ''});
                })

			},
        },
    }
</script>

<style lang="scss">
    @import "@/scss/views/Login.scss";
</style>
